// import { BarcodeFormat, BrowserMultiFormatReader, NotFoundException } from '@zxing/library';
// import { useEffect, useRef, useState } from 'react';
// import { logDebug, logError } from '../../../utils/logger';

// const BarcodeScanner: React.FC = () => {
//   const videoRef = useRef<HTMLVideoElement | null>(null);
//   const [barcode, setBarcode] = useState<string | null>(null);
//   const [loading, setLoading] = useState<boolean>(false);
//   const [isBarcodeCorrect, setIsBarcodeCorrect] = useState<boolean | null>(null);
//   const [showConfirmationDialog, setShowConfirmationDialog] = useState<boolean>(false);
//   const [error, setError] = useState<string | null>(null); // State for general errors
//   const codeReaderRef = useRef<BrowserMultiFormatReader | null>(null); // Ref for codeReader

// //   const [zoom, setZoom] = useState(1); // Zoom level (1 = normal)
// // const [position, setPosition] = useState({ x: 50, y: 50 }); // Center focus

//   // New state to track if a barcode has been decoded
//   const [hasDecoded, setHasDecoded] = useState(false); 

//   useEffect(() => {
//     codeReaderRef.current = new BrowserMultiFormatReader();
//     let currentStream: MediaStream | null = null;

//     const startScanning = async () => {
//       setLoading(true);
//       setError(null); // Clear any previous errors
//       try {
//         const constraints = {
//             video: {
//             //   width: { ideal: 1920 }, // Try to get 1080p (Full HD)
//             //   height: { ideal: 1080 },
//               facingMode: 'environment', // Use back camera if available
//             },
//           };
//         const stream = await navigator.mediaDevices.getUserMedia(constraints);
//         currentStream = stream;
//         if (videoRef.current) {
//           videoRef.current.srcObject = stream;
//           videoRef.current.onloadedmetadata = () => {
//             videoRef.current?.play().catch((err) => {
//               logError('Error starting video playback:', err);
//               setError("Error starting video. Please check camera permissions.");
//             });
//           };

//           (codeReaderRef.current as BrowserMultiFormatReader).decodeFromVideoDevice(null, videoRef.current, (result, error) => {
//             if (result && !showConfirmationDialog && !hasDecoded) { // Check hasDecoded here
//               if (result.getBarcodeFormat() === BarcodeFormat.UPC_A) {
//                 setBarcode(result.getText());
//                 // let points = result.getResultPoints();
//                 setShowConfirmationDialog(true);
//                 pauseVideo();
//                 setHasDecoded(true); // Set hasDecoded to true after successful decode
//               }
//             }
//             if (error && !(error instanceof NotFoundException)) {
//               logError('Decoding error:', error);
//               setError("Error decoding barcode. Please try again.");
//               pauseVideo();
//             }
//           });
//         }
//       } catch (err) {
//         logError('Error accessing the camera:', err);
//         setError("Error accessing camera. Please check permissions.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     startScanning();

//     return () => {
//       codeReaderRef.current?.reset();
//       if (currentStream) {
//         currentStream.getTracks().forEach((track) => track.stop());
//       }
//       if (videoRef.current) {
//         videoRef.current.srcObject = null;
//       }
//     };
//   }, []);

//   const pauseVideo = () => {
//     if (videoRef.current && !videoRef.current.paused) {
//       videoRef.current.pause();
//     }
//   };

// //   const handleZoom = (event: React.MouseEvent<HTMLVideoElement>) => {
// //     if (!videoRef.current) return;

// //     const rect = videoRef.current.getBoundingClientRect();
// //     const x = ((event.clientX - rect.left) / rect.width) * 100; // Convert to percentage
// //     const y = ((event.clientY - rect.top) / rect.height) * 100;

// //     setPosition({ x, y }); // Move focus to clicked position
// //     setZoom((prevZoom) => Math.min(prevZoom + 0.5, 3)); // Increase zoom (max 3x)
// //   };

// //   const resetZoom = () => {
// //     setZoom(1);
// //     setPosition({ x: 50, y: 50 });
// //   };

//   const restartScanning = () => {
//     setIsBarcodeCorrect(false);
//     setShowConfirmationDialog(false);
//     setHasDecoded(false); // Reset hasDecoded when restarting
//     if (videoRef.current) {
//       videoRef.current.play().catch((err) => {
//         logError('Error restarting video playback:', err);
//         setError("Error restarting video. Please try again.");
//       });
//     }
//   };

// //   const handleFocus = async (event: React.MouseEvent<HTMLVideoElement>) => {
// //     if (!videoRef.current || !videoRef.current.srcObject) return;

// //     const stream = videoRef.current.srcObject as MediaStream;
// //     const track = stream.getVideoTracks()[0]; // Get the active video track

// //     if (!track) return;

// //     const capabilities = track.getCapabilities(); // Get camera capabilities

// //     if ('focusMode' in capabilities) {
// //       try {
// //         const constraints = track.getConstraints();

// //         const rect = videoRef.current.getBoundingClientRect();

// //         // Normalize click position to [0, 1] range
// //         const x = (event.clientX - rect.left) / rect.width;
// //         const y = (event.clientY - rect.top) / rect.height;

// //         logInfo(`Focusing at: x=${x}, y=${y}`);

// //         // Apply focus point if supported
// //         await track.applyConstraints({
// //           advanced: [
// //             {
// //               focusMode: 'continuous', // Try 'auto' or 'manual' if available
// //               focusDistance: capabilities.focusDistance
// //                 ? capabilities.focusDistance.max || 10
// //                 : undefined,
// //               pointsOfInterest: [{ x, y }], // Some cameras support this
// //             },
// //           ],
// //         });
// //       } catch (error) {
// //         logError('Focus adjustment failed:', error);
// //       }
// //     } else {
// //       logWarn('Camera does not support focusMode adjustments.');
// //     }
// //   };


//   const handleConfirm = () => {
//     setShowConfirmationDialog(false); 
//     logDebug('Barcode confirmed: ' + barcode);
//     setIsBarcodeCorrect(true);
//   };

//   const handleCancel = () => {
//     setIsBarcodeCorrect(false);
//     setShowConfirmationDialog(false);
//     setBarcode(null);
//     restartScanning(); // Restart scanning after canceling
//   };

//   return (
//     <div >
//       <h1 >Redeem Pedegree Gift Certificate</h1>
//       <div >
//         <h2>Position Barcode in front of Camera</h2>
//         <video 
//             ref={videoRef} 
//             autoPlay 
//             muted 
//             playsInline 
//             autoFocus
//             // style={{
//             //     width: "100%",
//             //     height: "100%",
//             //     transform: `scale(${zoom}) translate(${(50 - position.x) / zoom}%, ${(50 - position.y) / zoom}%)`,
//             //     transformOrigin: "center",
//             //     objectFit: "cover",
//             //     cursor: "pointer",
//             //   }}
//             //   onClick={handleZoom} // Click to zoom in
//             /> {/* Added autoplay, muted, and playsInline */}
//         {loading && <p>Loading camera...</p>}
//         {/* <button onClick={resetZoom}>Reset Zoom</button> */}
//         {error && <p style={{ color: 'red' }}>{error}</p>} {/* Display errors */}
//         {!videoRef.current?.srcObject && !loading && !error && <p>Waiting for camera access...</p>} {/* Message when camera access is pending */}
//       </div>

//       {showConfirmationDialog && barcode && (
//         <div >
//           <h2>Is this the correct barcode?</h2>
//           <p>{barcode}</p>
//           <div>
//             <button onClick={handleConfirm}>Confirm</button>
//             <button onClick={handleCancel}>Cancel</button>
//           </div>
//         </div>
//       )}

//     {isBarcodeCorrect !== null && !showConfirmationDialog && (
//       <div >
//         <h2>
//           {isBarcodeCorrect ? (
//             <>
//               You have redeemed your gift certificate!
//               <p>{'Barcode: ' + barcode}</p>
//             </>
//           ) : (
//             <>
//               <p>Please scan again.</p>
//             </>
//           )}
//         </h2>
//       </div>
//     )}
//     </div>
//   );
// };

// export default BarcodeScanner;

// import { Box, Button, Card, CardContent, Typography } from "@mui/material";
// import { BarcodeFormat, BrowserMultiFormatReader, NotFoundException, ResultPoint } from "@zxing/library";
// import React, { useEffect, useRef, useState } from "react";
// import { logDebug, logError } from "../../../utils/logger";

// const BarcodeScanner: React.FC = () => {
//   const videoRef = useRef<HTMLVideoElement | null>(null);
//   const canvasRef = useRef<HTMLCanvasElement | null>(null);
//   const codeReaderRef = useRef<BrowserMultiFormatReader | null>(null);

//   const [barcode, setBarcode] = useState<string | null>(null);
//   const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
//   const [isBarcodeCorrect, setIsBarcodeCorrect] = useState<boolean | null>(null);
//   const [error, setError] = useState<string | null>(null);
//   const [loading, setLoading] = useState(false);
//   const [hasDecoded, setHasDecoded] = useState(false);

//   // Store the original camera feed resolution
//   const [rawWidth, setRawWidth] = useState(1920);
//   const [rawHeight, setRawHeight] = useState(1080);

//   useEffect(() => {
//     codeReaderRef.current = new BrowserMultiFormatReader();
//     let currentStream: MediaStream | null = null;

//     const startScanning = async () => {
//       setLoading(true);
//       setError(null);

//       try {
//         const constraints = {
//           video: {
//             width: { ideal: 1920 }, // Set to high resolution
//             height: { ideal: 1080 },
//             facingMode: "environment",
//           },
//         };
//         const stream = await navigator.mediaDevices.getUserMedia(constraints);
//         currentStream = stream;

//         if (videoRef.current) {
//           videoRef.current.srcObject = stream;
//           videoRef.current.onloadedmetadata = () => {
//             setRawWidth(videoRef.current!.videoWidth);
//             setRawHeight(videoRef.current!.videoHeight);
//             videoRef.current?.play().catch((err) => {
//               logError("Error starting video playback:", err);
//               setError("Error starting video. Please check camera permissions.");
//             });
//           };

//           codeReaderRef.current?.decodeFromVideoDevice(
//             null,
//             videoRef.current,
//             (result, error) => {
//               if (result && !showConfirmationDialog && !hasDecoded) {
//                 if (result.getBarcodeFormat() === BarcodeFormat.UPC_A) {
//                   setBarcode(result.getText());
//                   setShowConfirmationDialog(true);
//                   drawBoundingBox(result.getResultPoints());
//                   pauseVideo();
//                   setHasDecoded(true);
//                 }
//               }
//               if (error && !(error instanceof NotFoundException)) {
//                 logError("Decoding error:", error);
//                 setError("Error decoding barcode. Please try again.");
//                 pauseVideo();
//               }
//             }
//           );
//         }
//       } catch (err) {
//         logError("Error accessing the camera:", err);
//         setError("Error accessing camera. Please check permissions.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     startScanning();

//     return () => {
//       codeReaderRef.current?.reset();
//       if (currentStream) {
//         currentStream.getTracks().forEach((track) => track.stop());
//       }
//       if (videoRef.current) {
//         videoRef.current.srcObject = null;
//       }
//     };
//   }, []);

//   const pauseVideo = () => {
//     if (videoRef.current && !videoRef.current.paused) {
//       videoRef.current.pause();
//     }
//   };

//   const stopVideo = () => {
//     if (videoRef.current) {
//         videoRef.current.srcObject = null;
//         videoRef.current = null;
//     }
//   }

//   const restartScanning = () => {
//     setIsBarcodeCorrect(false);
//     setShowConfirmationDialog(false);
//     setHasDecoded(false);
//     clearBoundingBox();

//     if (videoRef.current) {
//       videoRef.current.play().catch((err) => {
//         logError("Error restarting video playback:", err);
//         setError("Error restarting video. Please try again.");
//       });
//     }
//   };

//   const drawBoundingBox = (points: ResultPoint[]) => {
//     if (!canvasRef.current || !videoRef.current) return;
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");

//     if (!ctx) return;
//     ctx.clearRect(0, 0, canvas.width, canvas.height);

//     const scaleX = 300 / rawWidth; // Scale to 300px width
//     const scaleY = 300 / rawHeight; // Scale to 300px height

//     if (points.length >= 2) {
//       const [p1, p2] = points;
//       const adjustedX = p1.getX() * scaleX;
//       const adjustedY = p1.getY() * scaleY;
//       const width = Math.abs(p2.getX() - p1.getX()) * scaleX;
//       const height = Math.abs(p2.getY() - p1.getY()) * scaleY;

//       //Increase line length by 50%
//       const lengthIncrease = 0.5;
//         const adjustedWidth = width * (1 + lengthIncrease);
//         const startingX = adjustedX - (adjustedWidth - width) / 2;

//         const adjustedHeight = height * (1 + lengthIncrease);
//         const startingY = adjustedY - (adjustedHeight - height) / 2;

//       ctx.strokeStyle = "red";
//       ctx.lineWidth = 2;
//       ctx.strokeRect(startingX, startingY, adjustedWidth, adjustedHeight);
//     }
//   };

//   const clearBoundingBox = () => {
//     if (!canvasRef.current) return;
//     const ctx = canvasRef.current.getContext("2d");
//     if (ctx) ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
//   };

//   const handleConfirm = () => {
//     setShowConfirmationDialog(false);
//     logDebug("Barcode confirmed: " + barcode);
//     setIsBarcodeCorrect(true);
//     setBarcode(null);
//     stopVideo();
//   };

//   const handleCancel = () => {
//     setIsBarcodeCorrect(false);
//     setShowConfirmationDialog(false);
//     setBarcode(null);
//     restartScanning();
//   };

//   return (
//     <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt: 4 }}>
//       <Typography variant="h4" gutterBottom>
//         Redeem Gift Certificate
//       </Typography>

//       {/* Video and Canvas Container */}
//       <Box
//         sx={{
//           width: 300,
//           height: 300,
//           position: "relative",
//           border: "2px solid #ccc",
//           borderRadius: "8px",
//           overflow: "hidden",
//         }}
//       >
//         <video ref={videoRef} autoPlay muted playsInline style={{ width: "100%", height: "100%", objectFit: "cover" }} />
//         <canvas ref={canvasRef} width={300} height={300} style={{ position: "absolute", top: 0, left: 0, pointerEvents: "none" }} />
//       </Box>

//       {error && <Typography color="error">{error}</Typography>}

//       {showConfirmationDialog && barcode && (
//         <Card sx={{ mt: 3, p: 2, textAlign: "center", width: "100%", maxWidth: "400px" }}>
//           <CardContent>
//             <Typography variant="h6">Is this the correct barcode?</Typography>
//             <Typography variant="body1" sx={{ fontWeight: "bold", mt: 1 }}>
//               {barcode}
//             </Typography>
//             <Box sx={{ mt: 2 }}>
//               <Button variant="contained" color="primary" onClick={handleConfirm} sx={{ mr: 1 }}>
//                 Confirm
//               </Button>
//               <Button variant="outlined" color="secondary" onClick={handleCancel}>
//                 Cancel
//               </Button>
//             </Box>
//           </CardContent>
//         </Card>
//       )}

//       {isBarcodeCorrect !== null && !showConfirmationDialog && (
//         <Card sx={{ mt: 3, p: 2, textAlign: "center", width: "100%", maxWidth: "400px" }}>
//           <CardContent>
//             <Typography variant="h6">
//               {isBarcodeCorrect ? "You have redeemed your gift certificate!" : "Please scan again."}
//             </Typography>
//             {isBarcodeCorrect && (
//               <Typography variant="body1" sx={{ fontWeight: "bold", mt: 1 }}>
//                 Barcode: {barcode}
//               </Typography>
//             )}
//           </CardContent>
//         </Card>
//       )}

//       <Button variant="contained" color="primary" sx={{ mt: 3 }} onClick={restartScanning}>
//         Restart Scanning
//       </Button>
//     </Box>
//   );
// };

// export default BarcodeScanner;


import { Box, Button, Card, CardContent, CircularProgress, Divider, Typography } from "@mui/material";
import { BarcodeFormat, BrowserMultiFormatReader, NotFoundException, ResultPoint } from "@zxing/library";
import React, { useEffect, useRef, useState } from "react";
import { logDebug, logError } from "../../../utils/logger";

const BarcodeScanner: React.FC = () => {
    const videoRef = useRef<HTMLVideoElement | null>(null);
    const canvasRef = useRef<HTMLCanvasElement | null>(null);
    const codeReaderRef = useRef<BrowserMultiFormatReader | null>(null);

    const [barcode, setBarcode] = useState<string | null>(null);
    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
    const [isBarcodeCorrect, setIsBarcodeCorrect] = useState<boolean | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [hasDecoded, setHasDecoded] = useState(false);

    // Define scanning box size inside the viewport (200x100 centered)
    const scanBoxWidth = 200;
    const scanBoxHeight = 100;
    const viewportWidth = 300;
    const viewportHeight = 300;

    useEffect(() => {
        codeReaderRef.current = new BrowserMultiFormatReader();
        let currentStream: MediaStream | null = null;

        const startScanning = async () => {
            setLoading(true);
            setError(null);

            try {
                const constraints = {
                    video: {
                        width: { ideal: 1920 }, // Set to high resolution
                        height: { ideal: 1080 },
                        facingMode: "environment",
                    },
                };
                const stream = await navigator.mediaDevices.getUserMedia(constraints);
                currentStream = stream;

                if (videoRef.current) {
                    videoRef.current.srcObject = stream;
                    videoRef.current.onloadedmetadata = () => {
                        videoRef.current?.play().catch((err) => {
                            logError("Error starting video playback:", err);
                            setError("Error starting video. Please check camera permissions.");
                        });
                    };

                    drawScanningOverlay(); // Draws the scanning box and dims outside

                    codeReaderRef.current?.decodeFromVideoDevice(
                        null,
                        videoRef.current,
                        (result, error) => {
                            if (result && !showConfirmationDialog && !hasDecoded) {
                                if (result.getBarcodeFormat() === BarcodeFormat.UPC_A) {
                                    setBarcode(result.getText());
                                    setShowConfirmationDialog(true);
                                    drawBoundingBox(result.getResultPoints());
                                    pauseVideo();
                                    setHasDecoded(true);
                                }
                            }
                            if (error && !(error instanceof NotFoundException)) {
                                logError("Decoding error:", error);
                                setError("Error decoding barcode. Please try again.");
                                pauseVideo();
                            }
                        }
                    );
                }
            } catch (err) {
                logError("Error accessing the camera:", err);
                setError("Error accessing camera. Please check permissions.");
            } finally {
                setLoading(false);
            }
        };

        startScanning();

        return () => {
            codeReaderRef.current?.reset();
            if (currentStream) {
                currentStream.getTracks().forEach((track) => track.stop());
            }
            if (videoRef.current) {
                videoRef.current.srcObject = null;
            }
        };
    }, []);

    const pauseVideo = () => {
        if (videoRef.current && !videoRef.current.paused) {
            videoRef.current.pause();
        }
    };

    const restartScanning = () => {
        setIsBarcodeCorrect(false);
        setShowConfirmationDialog(false);
        setHasDecoded(false);
        clearCanvas();
        drawScanningOverlay();

        if (videoRef.current) {
            videoRef.current.play().catch((err) => {
                logError("Error restarting video playback:", err);
                setError("Error restarting video. Please try again.");
            });
        }
    };

    // Draw the scanning box and dim everything outside
    const drawScanningOverlay = () => {
        if (!canvasRef.current) return;
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");

        if (!ctx) return;
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // Dim entire area
        ctx.fillStyle = "rgba(0, 0, 0, 0.6)";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // Cut out the scanning area
        ctx.clearRect(
            (viewportWidth - scanBoxWidth) / 2,
            (viewportHeight - scanBoxHeight) / 2,
            scanBoxWidth,
            scanBoxHeight
        );

        // Draw scanning box
        ctx.strokeStyle = "red";
        ctx.lineWidth = 2;
        ctx.strokeRect(
            (viewportWidth - scanBoxWidth) / 2,
            (viewportHeight - scanBoxHeight) / 2,
            scanBoxWidth,
            scanBoxHeight
        );
    };

    // Draw a bounding box around the detected barcode
    const drawBoundingBox = (points: ResultPoint[]) => {
        if (!canvasRef.current) return;
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");

        if (!ctx) return;

        if (points.length >= 2) {
            const [p1, p2] = points;

            ctx.strokeStyle = "blue";
            ctx.lineWidth = 2;
            ctx.strokeRect(p1.getX(), p1.getY(), p2.getX() - p1.getX(), p2.getY() - p1.getY());
        }
    };

    const clearCanvas = () => {
        if (!canvasRef.current) return;
        const ctx = canvasRef.current.getContext("2d");
        if (ctx) ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
    };

    const handleConfirm = () => {
        setShowConfirmationDialog(false);
        logDebug("Barcode confirmed: " + barcode);
        setIsBarcodeCorrect(true);
    };

    const handleCancel = () => {
        setIsBarcodeCorrect(false);
        setShowConfirmationDialog(false);
        setBarcode(null);
        restartScanning();
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt: 4 }}>
            {/* <Typography variant="h4" gutterBottom>
                Redeem Gift Certificate
            </Typography> */}

            {/* Video and Canvas Container */}
            {error && <Typography color="error">{error}</Typography>}

            {loading ? <CircularProgress /> :
                <>
                    <Box
                        sx={{
                            width: viewportWidth,
                            height: viewportHeight,
                            position: "relative",
                            border: "2px solid #ccc",
                            borderRadius: "8px",
                            overflow: "hidden",
                        }}
                    >
                        <video ref={videoRef} autoPlay muted playsInline style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                        <canvas ref={canvasRef} width={viewportWidth} height={viewportHeight} style={{ position: "absolute", top: 0, left: 0, pointerEvents: "none" }} />
                    </Box>
                    <Button variant="contained" color="primary" sx={{ mt: 3 }} onClick={restartScanning}>
                        Restart Scanning
                    </Button>
                    
                </>
            }





            {showConfirmationDialog && barcode && (
                <Card sx={{ mt: 3, p: 2, textAlign: "center", width: "100%", maxWidth: "400px" }}>
                    <CardContent>
                        <Typography variant="h6">Is this the correct barcode?</Typography>
                        <Typography variant="body1" sx={{ fontWeight: "bold", mt: 1 }}>
                            {barcode}
                        </Typography>
                        <Box sx={{ mt: 2 }}>
                            <Button variant="contained" color="primary" onClick={handleConfirm} sx={{ mr: 1 }}>
                                Confirm
                            </Button>
                            <Button variant="outlined" color="secondary" onClick={handleCancel}>
                                Cancel
                            </Button>
                        </Box>
                    </CardContent>
                </Card>
            )}

            {isBarcodeCorrect !== null && !showConfirmationDialog && (
                <Card sx={{ mt: 3, p: 2, textAlign: "center", width: "100%", maxWidth: "400px" }}>
                    <CardContent>
                        <Typography variant="h6">
                            {isBarcodeCorrect ? "You have redeemed your gift certificate!" : "Please scan again."}
                        </Typography>
                        {isBarcodeCorrect && (
                            <Typography variant="body1" sx={{ fontWeight: "bold", mt: 1 }}>
                                Barcode: {barcode}
                            </Typography>
                        )}
                    </CardContent>
                </Card>
            )}

<Divider sx={{ mt: 3 }} />
        </Box>
    );
};

export default BarcodeScanner;
